<template>
    <main id="main" class="main">
  
       <section class="section">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body p-4">
                <div class="row">
                  <div class="col-sm-9">
                    <div class="pagetitle"> 
                      <h1 class="text-left">INSTANCES</h1>
                      <nav>
                        <ol class="breadcrumb breadJa">
                          <router-link :to="{ name: 'home' }" class="breadcrumb-item">Home</router-link>
                          <router-link :to="{ name: 'instances' }" class="breadcrumb-item">Instances</router-link>
                        </ol>
                      </nav>
                    </div>
                  </div> 
                  <div class="col-3">
                    <!-- button tambahan -->
                  </div>
                </div>

                <div class="row align-items-center mb-3">
                  <div class="col-md-6 mb-3 mb-md-0">
                    <button
                      class="btn btn-primary me-2 shadow-sm"
                      @click="handleAddInstance"
                      :disabled="loading"
                    >
                      <i class="bi bi-server me-1"></i>
                      Tambah Instance
                    </button>
                    <button
                      class="btn btn-outline-secondary"
                      @click="fetchData"
                      :disabled="loading"
                    >
                      <i class="bi bi-arrow-repeat"></i>
                      Fetch Data
                    </button>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex justify-content-md-end align-items-center">
                      <span class="me-2 text-muted small">Show</span>
                      <select v-model="selectedEntries" class="form-select form-select-sm" style="width: auto;" @change="currentPage = 1; fetchData()">
                        <option :value="10">10</option>
                        <option :value="20">20</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                      </select>
                      <span class="ms-2 text-muted small">entries</span>
                    </div>
                  </div>
                </div>

                <!-- table -->
                <div class="table-responsive">
                  <table class="table table-hover table-bordered caption-top">
                    <caption class="pb-2 pt-1">List of Instances</caption>

                    <!-- THEAD cukup sekali, tanpa <tr> di dalam <tr> -->
                    <thead class="table-primary">
                      <tr style="vertical-align:middle; text-align: center;">
                        <th scope="col">No</th>
                        <th scope="col">Instance ID</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Status</th>
                        <th scope="col">Connected</th>
                        <th scope="col" nowrap>Grup (Circle)</th>
                        <th scope="col">Used</th>
                        <th scope="col" nowrap>Webhook</th>
                        <th scope="col">Keterangan</th>
                        <th scope="col">Aksi</th>
                        <!-- tambahkan kolom action kalau mau -->
                      </tr>
                    </thead>

                    <tbody class="table-group-divider">
                      <tr v-if="loading">
                        <td colspan="20">
                          <div class="d-flex justify-content-center text-primary m-3">
                            <strong role="status" class="pt-1" style="padding-right: 2rem;">Loading...</strong>
                            <div class="spinner-border shadow" aria-hidden="true"></div>
                          </div>
                        </td>
                      </tr>

                      <tr
                        v-else
                        v-for="item in items"
                        :key="item.instanceId"
                        style="vertical-align:middle;"
                        class="fade-in-pengaduan-view"
                      >
                        <th scope="row" width="5%" style="text-align: center;" nowrap>
                          {{ item.number }}
                        </th>
                        <td nowrap width="10%" style="text-align: center;">{{ item.instanceId.substring(0, 6) }}</td>
                        <td nowrap style="text-align: center;">{{ item.phoneNumber || '-' }}</td>
                        <td nowrap style="text-align: center; ">
                          <span
                            class="badge rounded-pill statuslogin-badge"
                            :class="{ 
                              'bg-warning': item.status === 'qr_required',
                              'bg-success': item.status === 'online',
                              'bg-secondary': item.status === 'logged_out',
                              'bg-danger': item.status === 'disconnected'
                            }"
                          >
                            {{ formatStatusLabel(item) }}
                          </span>
                        </td>
                        <td nowrap style="text-align: center;" width="5%">
                          <i
                            class="bi"
                            :class="item.isConnected ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'"
                          ></i>
                        </td>
                        <td nowrap style="text-align: center;" width="5%">{{ item.circle || '-' }}</td>
                        <td nowrap style="text-align: center;" width="5%">
                          <i
                            class="bi"
                            :class="item.used ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-secondary'"
                            :title="item.used ? 'Siap Digunakan' : 'Tidak Tersedia'"
                          ></i>
                        </td>
                        <td nowrap style="text-align: center;" width="5%">
                          <span 
                            v-if="item.webhookUrl || item.webhook_url"
                            class="badge bg-success shadow-sm"
                            style="font-size: 0.75rem; cursor: pointer; color: #ffffff !important;"
                            :title="item.webhookUrl || item.webhook_url"
                            @click="openWebhookModal(item)"
                          >
                            <i class="bi bi-link-45deg me-1"></i>Active
                          </span>
                          <span 
                            v-else 
                            class="badge bg-secondary shadow-sm"
                            style="font-size: 0.75rem; cursor: pointer; color: #ffffff !important;"
                            title="Webhook belum diset"
                            @click="openWebhookModal(item)"
                          >
                            <i class="bi bi-dash"></i> None
                          </span>
                        </td>
                        <td style="text-align: left; max-width: 100px;">
                          <span 
                            class="text-truncate d-inline-block" 
                            style="max-width: 100px;"
                            :title="item.keterangan || '-'"
                          >
                            {{ item.keterangan || '-' }}
                          </span>
                        </td>
                        <td nowrap width="5%"  style="text-align: center;">
                          <!-- Tombol View Detail -->
                          <button
                              class="btn btn-sm btn-outline-info me-1"
                              @click="viewInstanceDetail(item)"
                              title="View Detail"
                            >
                              <i class="bi bi-eye"></i>
                          </button>
                          <!-- Tombol Edit Instance -->
                          <button
                              class="btn btn-sm btn-outline-warning me-1"
                              @click="openEditModal(item)"
                              title="Edit Instance"
                            >
                              <i class="bi bi-pencil-square"></i>
                          </button>
                          <!-- Tombol Webhook Setting -->
                          <button
                              class="btn btn-sm btn-outline-primary me-1"
                              @click="openWebhookModal(item)"
                              title="Webhook Settings"
                            >
                              <i class="bi bi-link-45deg"></i>
                          </button>
                          <!-- Tombol Scan / Login -->
                          <button
                              class="btn btn-sm btn-primary me-1 shadow-sm"
                              data-bs-toggle="modal"
                              data-bs-target="#qrModal"
                              @click="openQRModal(item.instanceId)"
                            >
                              <i class="bi bi-qr-code-scan me-1"></i>QR
                          </button>
                          <!-- Tombol Logout -->
                          <button 
                            class="btn btn-sm btn-outline-danger me-1" 
                            @click="handleLogout(item)" 
                            :disabled="item.status !== 'online'"
                          >
                            <i class="bi bi-box-arrow-right me-1"></i> DC
                          </button>
                          <button
                            class="btn btn-sm btn-outline-danger"
                            @click="handleDeleteInstance(item)"
                            :disabled="item.existsInWhatsmeow === true && item.status != 'qr_required'"
                          >
                            <i class="bi bi-trash me-1"></i> Del Inst
                          </button>
                        </td>

                      </tr>

                      <tr v-if="!loading && items.length === 0">
                        <td colspan="11" class="text-center">No results found.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Pagination & Entries Info -->
                <div class="row align-items-center mt-3">
                  <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
                    <p class="text-muted mb-0 small">
                      Showing {{ startEntryData }} to {{ endEntryData }} of {{ totalItemsData }} entries
                    </p>
                  </div>
                  <div class="col-md-6">
                    <nav aria-label="Page navigation" v-if="totalPages > 1">
                      <ul class="pagination justify-content-center justify-content-md-end mb-0">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <button class="page-link" @click="changePage(currentPage - 1)" aria-label="Previous">
                            <span aria-hidden="true">&laquo;</span>
                          </button>
                        </li>
                        <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: currentPage === page }">
                          <button class="page-link" @click="changePage(page)">{{ page }}</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <button class="page-link" @click="changePage(currentPage + 1)" aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main><!-- End #main -->

    <!-- Modal Scan QR -->
    <div class="modal fade" id="qrModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog">
        <div class="modal-content">
          <div class="modal-header py-2">
            <h6 class="modal-title mb-0">Scan QR Code</h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cleanupModal"></button>
          </div>

          <div class="modal-body p-2 text-center">
            <!-- Loading/Generating State -->
            <div v-if="qrStatus === 'generating'" class="py-3">
              <div class="illustration-container">
                <Vue3Lottie  
                  animationLink="/assets/qrcode.json"
                  :height="280" 
                  :width="280"
                  :loop="true"
                  :autoPlay="true"
                />
              </div>
              <div class="small text-muted">Generating QR code...</div>
              <div class="small text-muted mt-1">QR will auto-refresh, please wait</div>
            </div>

            <!-- QR SUCCESS menunggu connected/online -->
            <div v-else-if="qrStatus === 'qr_success'" class="py-3">
              <div class="illustration-container">
                <Vue3Lottie  
                  animationLink="/assets/pairing.json"
                  :height="280" 
                  :width="280"
                  :loop="true"
                  :autoPlay="true"
                />
              </div>
              <div class="small text-muted">Pairing Process...</div>
              <div class="small text-muted mt-1">QR Success, waiting for pairing</div>
            </div>

            <!-- Error State -->
            <div v-else-if="qrStatus === 'error'" class="py-3">
              <div v-if="qrProgressBackground === 'QR_IN_PROGRESS'" class="illustration-container">
                <Vue3Lottie  
                  animationLink="/assets/qrcode.json"
                  :height="280" 
                  :width="280"
                  :loop="true"
                  :autoPlay="true"
                />
              </div>
              <div v-else-if="qrProgressBackground === 'INSTANCE_LOGGED_OUT'" class="illustration-container">
                <Vue3Lottie  
                  animationLink="/assets/failed.json"
                  :height="280" 
                  :width="280"
                  :loop="true"
                  :autoPlay="true"
                />
                
              </div>
              <i v-else class="bi bi-exclamation-circle text-danger" style="font-size: 2rem;"></i><hr>
              <div class="small text-danger mt-2">{{ qrError }}</div>
            </div>

            <!-- Timeout State -->
            <div v-else-if="qrStatus === 'timeout'" class="py-3">
              <i class="bi bi-clock-history text-warning" style="font-size: 2rem;"></i>
              <div class="small text-warning mt-2">QR generation timeout</div>
              <div class="small text-muted">Please click “Generate QR” to try again.</div>
            </div>

            <!-- Connected State -->
            <div v-else-if="qrStatus === 'connected'" class="py-3">
              <i class="bi bi-check-circle text-success" style="font-size: 2rem;"></i>
              <div class="small text-success mt-2">Connected successfully!</div>
            </div>

            <!-- Online State -->
            <div v-else-if="qrStatus === 'already_connected'" class="py-3">
              <div class="illustration-container">
                <Vue3Lottie  
                  animationLink="/assets/success.json"
                  :height="280" 
                  :width="280"
                  :loop="true"
                  :autoPlay="true"
                />
              </div>
              <div class="small text-success mt-2">Already Connected!</div>
            </div>

            <!-- QR Code Display -->
            <div v-else-if="qrImage && qrStatus === 'ready'">
              <img
                :src="qrImage"
                alt="QR Code"
                class="img-fluid"
                style="max-width: 300px;"
              />
              <div class="small text-muted mt-2">
                <i class="bi bi-phone"></i> Scan with WhatsApp
              </div>
              <div class="small text-muted">
                QR auto-refreshes if expired
              </div>
            </div>

            <!-- No QR Available -->
            <div v-else class="py-3">
              <i class="bi bi-qr-code" style="font-size: 2rem; color: #ccc;"></i>
              <div class="small text-muted mt-2">QR not available</div>
              <div class="small text-muted">Click "Generate QR" to start</div>
            </div>
          </div>

          <div class="modal-footer py-2">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="cleanupModal">Close</button>
            <!-- qrProgressBackground === 'QR_IN_PROGRESS' pakai ini jika progress tetap mau di stop-->
            <button
              v-if="qrStatus === 'generating' || qrStatus === 'ready'"
              type="button"
              class="btn btn-danger btn-sm"
              @click="cancelQR"
            >
              <i class="bi bi-x-circle"></i> Cancel QR Generation Process
            </button>
          </div>
        </div>
      </div>
    </div>




  </template> 
  <script>
  import axios from 'axios';
  import QRCode from 'qrcode';
  import { Vue3Lottie } from 'vue3-lottie';
  import lottie from 'lottie-web';
  import { useSystem } from '@/composables/useSystem.js';

  
  export default {
    components:{
      Vue3Lottie
    },
    setup() {
      const { themeColor } = useSystem();
      return { themeColor };
    },
    data() {
      return {
        items: [],
        currentPage: 1,
        // totalPages: 0,
        totalPages: 1,
        searchQuery: '',
        selectedEntries: 20, 
        baseUrl: process.env.VUE_APP_BE_APP_BASE_URL,
        loading: false,
        startEntryData : 0,
        endEntryData: 0,
        totalItemsData : 0, 

        // WebSocket
        ws: null, // TAMBAHKAN INI
        wsConnected: false, // TAMBAHKAN INI (optional, untuk tracking status)
        wsRetryCount: 0, // counter retry

        // untuk modal QR
        currentInstanceId: null,
        qrImage: null,
        qrStatus: null,
        qrProgressBackground: null,
        qrError: null,

        wsRetryTimeout: null,

      }
    },
    mounted() {
      this.fetchData();
      // Setup WebSocket listener
      this.setupWebSocket();
    },
    beforeUnmount() {
      if (this.wsRetryTimeout) {
        clearTimeout(this.wsRetryTimeout);
        this.wsRetryTimeout = null;
      }
      if (this.ws) {
        console.log('Closing WebSocket...');
        this.ws.close();
        this.ws = null;
      }
    },
 
    methods: {
      async fetchData() {
      console.log('fetchData CALLED at', new Date().toISOString());
        try {
          this.loading = true

          const response = await axios.get(
            `${this.baseUrl}/api/instances`,
            {
              params: {
                all: true, // sesuai yang kamu pakai di Postman
              }
            },
          )

          const instances = response.data.data.instances || []
          const total = response.data.data.total || instances.length

          // hitung nomor urut dan simpan semua instance
          const mapped = instances.map((item, index) => ({
            ...item,
            number: index + 1, // No urut global
          }))

          // simpan total dan paging FE
          this.totalItemsData = total
          this.totalPages = Math.max(1, Math.ceil(total / this.selectedEntries))

          // slice sesuai currentPage & selectedEntries
          const startIndex = (this.currentPage - 1) * this.selectedEntries
          const endIndex = startIndex + this.selectedEntries
          this.items = mapped.slice(startIndex, endIndex)

          // hitung info entries
          this.startEntryData = instances.length > 0 ? startIndex + 1 : 0
          this.endEntryData = Math.min(startIndex + this.selectedEntries, total)
        } catch (error) {
          console.error('Terjadi kesalahan:', error)
          if (error.response && error.response.status === 401) {
            this.Toasttt('Unauthorized. You do not have access.', 'warning')
          }
        } finally {
          this.loading = false
        }
      },

      changePage(page) {
        if (page >= 1 && page <= this.totalPages) {
          this.currentPage = page;
          this.fetchData();
        }
      },
      async handleAddInstance() { // tambah instance baru

        const result = await this.$swal.fire({
          title: 'Tambah instance baru?',
          html: `
            <div id="lottie-confirm-new" style="width:200px; height:200px; margin:0 auto;"></div>
              <p class="mt-2">Pilih kelompok untuk instance ini.</p>
              <select id="swal-select-circle" class="form-control">
                <option value="">-- Pilih kelompok --</option>
                <option value="one">one</option>
                <option value="two">two</option>
                <option value="three">three</option>
                <option value="four">four</option>
                <option value="five">five</option>
                <option value="six">six</option>
                <option value="seven">seven</option>
                <option value="eight">eight</option>
                <option value="nine">nine</option>
                <option value="ten">ten</option>
            </select>
          `,
          showCancelButton: true,
          confirmButtonText: 'Ya, buat',
          cancelButtonText: 'Batal',
          confirmButtonColor: this.themeColor,
          cancelButtonColor: '#6c757d',

          didOpen: () => {
            lottie.loadAnimation({
              container: document.getElementById('lottie-confirm-new'),
              renderer: 'svg',
              loop: true,
              autoplay: true,
              path: '/assets/input.json'
            })
          },

          preConfirm: () => {
            const circle = document.getElementById('swal-select-circle').value
            if (!circle) {
              this.$swal.showValidationMessage('Kelompok wajib dipilih')
              return false
            }
            return { circle }
          }
        })

        if (!result.isConfirmed || !result.value) return
        const circle = result.value.circle

        try {
          this.loading = true

          // 2) Kirim ke BE dengan payload { kelompok: circle }
          const res = await axios.post(
            `${this.baseUrl}/api/login`,
            { kelompok: circle },
            { withCredentials: true }
          )

          const body = res.data

          if (body?.success) {
            // 3) Success alert
            await this.$swal.fire({
              title: 'Instance berhasil dibuat!',
              html: `
                <div id="lottie-success-add" style="width:200px; height:200px; margin:0 auto;"></div>
                <p class="mt-2">Berhasil membuat instance baru di kelompok: <br><b>${circle}</b>.</p>
              `,
              confirmButtonText: 'OK',
              confirmButtonColor: this.themeColor,

              didOpen: () => {
                lottie.loadAnimation({
                  container: document.getElementById('lottie-success-add'),
                  renderer: 'svg',
                  loop: true,
                  autoplay: true,
                  path: '/assets/success.json'
                })
              }
            })
          } else {
            this.Toasttt(body?.message || 'Gagal membuat instance baru.', 'error')
          }

          await this.fetchData()
        } catch (error) {
          console.error('Gagal tambah instance:', error)
          this.Toasttt(
            'Gagal menambah instance',
            'error',
            error?.response?.data?.message || ''
          )
        } finally {
          this.loading = false
        }
      },

      async handleDeleteInstance(item) {
        if (!item || !item.instanceId) {
          return
        }

        const result = await this.$swal.fire({
          title: 'Hapus instance ini?',
          text: `Instance ${item.instanceId?.substring(0, 6)} akan dihapus permanen.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya, hapus',
          cancelButtonText: 'Batal',
          confirmButtonColor: '#dc3545',
          cancelButtonColor: '#6c757d',
        })

        if (!result.isConfirmed) {
          return
        }

        try {
          this.loading = true

          const res = await axios.delete(
            `${this.baseUrl}/api/instances/${item.instanceId}`,
            { withCredentials: true },
          )

          const body = res.data
          if (body?.success) {
            this.Toasttt( body.message || 'Instance berhasil dihapus.', 'success', )
          } else {
            this.Toasttt(body?.message || 'Gagal menghapus instance.', 'error'  )
          }

          // refresh list instances
          await this.fetchData()
        } catch (error) {
          console.error('Gagal hapus instance:', error)
          this.Toasttt('Gagal menghapus instance', 'error',  error?.response?.data?.message || '',
          )
        } finally {  this.loading = false }
      },


      async handleLogout(item) {
        try {

          const result = await this.$swal.fire({
            title: 'Disconnect instance?',
            html: `
              <div id="lottie-confirm" style="width:180px; height:180px; margin:0 auto;"></div>
              <p class="mt-2">Apakah Anda yakin ingin Disconnect instance ?<br><h4>${item.instanceId.substring(0, 6)} <b>(${item.phoneNumber})</b> </h4></p>
            `,
            showCancelButton: true,
            confirmButtonText: 'Ya, logout',
            cancelButtonText: 'Batal',
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',

            // 🔥 Lottie render di dalam konfirmasi
            didOpen: () => {
              lottie.loadAnimation({
                container: document.getElementById('lottie-confirm'),
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: '/assets/disconnect.json' // 🔥 lottie di bagian confirm
              });
            }
          });

          // ❌ Jika user tekan Batal → stop proses
          if (!result.isConfirmed) return;

          // 🔄 Lanjut logout
          this.loading = true;

          await axios.post(
            `${this.baseUrl}/api/logout/${item.instanceId}`,
            {},
            { withCredentials: true },
          );

          await this.fetchData();

          //SWEETALERT SUKSES + LOTTIE SUCCESS
          await this.$swal.fire({
            title: 'Berhasil Disconnect!',
            html: `
              <div id="lottie-success" style="width:220px; height:220px; margin:auto;"></div>
              <p class="mt-2">Instance <b>${item.instanceId.substring(0, 6)}</b> berhasil di-disconnect.</p>
            `,
            showConfirmButton: false,
            timer: 1500,
            didOpen: () => {
              lottie.loadAnimation({
                container: document.getElementById('lottie-success'),
                renderer: 'svg',
                loop: false,
                autoplay: true,
                path: '/assets/success.json' 
              });
            }
          });

          this.Toasttt('Berhasil logout instance.', 'success');

        } catch (error) {
          console.error('Gagal logout:', error);
          this.Toasttt(
            'Gagal logout instance',
            'error',
            error?.response?.data?.message || ''
          );
        } finally {
          this.loading = false;
        }
      },

      openQRModal(instanceId) {
        this.currentInstanceId = instanceId;
        this.qrStatus = null;
        this.qrImage = null;
        this.qrError = null;
        
        // Buka modal secara aman (menggunakan instance yang sudah ada jika ada)
        const modalElement = document.getElementById('qrModal');
        const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
        modal.show();
        
        // Generate QR
        this.generateQR();
      },

      // Generate QR Code
      async generateQR() {
        if (!this.currentInstanceId) return;
        
        this.qrStatus = 'generating';
        this.qrError = null;
        this.qrImage = null;
        
        try {
          const response = await axios.get(`/api/qr/${this.currentInstanceId}`);
          
          if (!response.data.success) {
            this.qrStatus = 'error';
            this.qrError = response.data.message || 'Failed to generate QR';
            return;
          }

          this.qrStatus = response.data.data.status;
          
          // WebSocket akan update qrImage dan status
          
        } catch (error) {
          this.qrStatus = 'error';
          if (error.response?.status === 401) {
            this.qrError = 'Authentication failed. Please login again.';
            // Optional: redirect to login
            this.$router.push({ name: 'login' });
          } else {
            this.qrProgressBackground = error.response?.data?.error?.code || null
            this.qrError = error.response?.data?.message || 'Failed to start QR generation';
          }
          
          console.error('QR generation error:', error);
        }
      },


      // Cancel QR Generation
      async cancelQR() {
        if (!this.currentInstanceId) return;
        this.loading = true;
        
        try {
          // ✅ Pakai axios (auto inject token)
          const response = await axios.delete(`/api/qr-cancel/${this.currentInstanceId}`);
          
          if (response.data.success) {
            this.qrStatus = 'cancelled';  // atau 'idle'
            this.qrImage = null;
            this.currentInstanceId = null;
            console.log('QR generation cancelled');
          }
        } catch (error) {
          console.error('Failed to cancel QR:', error);
          alert(error.response?.data?.message || 'Failed to cancel QR');
        } finally {
          this.loading = false;
        }
      },


      setupWebSocket() {

        if (this.ws && (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING)) {
          console.log('WebSocket already connected/connecting, skip new connection');
          return;
        }
        
        const wsUrl = process.env.VUE_APP_WS_APP_BASE_URL || 'ws://localhost:2121/ws';
        console.log('Connecting to WebSocket:', wsUrl, `(retry ${this.wsRetryCount})`);

        try {
          this.ws = new WebSocket(wsUrl);

          // on open
          this.ws.addEventListener('open', () => {
            console.log('✓ WebSocket connected');
            this.wsConnected = true;
            this.wsRetryCount = 0; // reset retry counter
          });

          // on message
          this.ws.addEventListener('message', (event) => {
            console.log('WebSocket message:', event.data);
            this.handleWebSocketMessage(event);
          });

          // on close
          this.ws.addEventListener('close', () => {
            console.log('✗ WebSocket disconnected');
            this.wsConnected = false;

            if (this.wsRetryTimeout) {
              clearTimeout(this.wsRetryTimeout);
              this.wsRetryTimeout = null;
            }

            if (this.wsRetryCount < 10) {
              this.wsRetryCount++;
              console.log(`Reconnecting WebSocket in 5s... (attempt ${this.wsRetryCount}/10)`);

              this.wsRetryTimeout = setTimeout(() => {
                this.setupWebSocket();
              }, 5000);
            } else {
              console.log('⚠️ WebSocket retry limit reached (10 attempts). Stopping reconnection.');
            }
          });

          // on error
          this.ws.addEventListener('error', (error) => {
            console.error('WebSocket error:', error);
            this.wsConnected = false;
          });

        } catch (error) {
          console.error('Failed to create WebSocket:', error);
        }
      },
      
      // Tambahkan async di handleWebSocketMessage
      async handleWebSocketMessage(event) {
        try {
          const wsData = JSON.parse(event.data);
          console.log('Parsed data:', wsData);

          // Handler untuk event perubahan status instance
          if (wsData.event === 'INSTANCE_STATUS_CHANGED') {
            const status = wsData.data?.status;
            const instanceId = wsData.data?.instance_id;
            console.log('INSTANCE_STATUS_CHANGED:', status, wsData.data);

            // Refresh instance list setiap status berubah
            this.fetchData();

            // Jika instance yang sedang dibuka di modal QR berubah status
            if (wsData.data?.instance_id === this.currentInstanceId) {
              // Tutup modal jika instance logout atau disconnect
              if (status === 'logged_out' || status === 'disconnected') {
                this.qrStatus = 'error';
                this.qrError = 'Instance has been logged out or disconnected';
                this.qrImage = null;
                this.cleanupModal();
              }

              // Tutup modal QR juga jika instance sudah connected atau status menjadi online
              if (status === 'connected' || status === 'online') {
                this.qrStatus = 'connected';
                this.qrImage = null;

                // this.cleanupModal();
                const modalElement = document.getElementById('qrModal');
                const qrModal = bootstrap.Modal.getInstance(modalElement);
                if (qrModal) {
                  qrModal.hide();
                }
                
                // Backup cleanup jika hide() bootstrap gagal membersihkan state
                this.cleanupModal();

                // Delay 500ms
                await new Promise(resolve => setTimeout(resolve, 500));

                // SWEETALERT SUCCESS + LOTTIE "success.json"
                await this.$swal.fire({
                  title: 'Akun berhasil ditautkan!',
                  html: `
                    <div id="lottie-success-add" style="width:200px; height:200px; margin:0 auto;"></div>
                    <p class="mt-2">Berhasil menautkan akun.</p>
                  `,
                  confirmButtonText: 'OK',
                  confirmButtonColor: this.themeColor,

                  didOpen: () => {
                    lottie.loadAnimation({
                      container: document.getElementById('lottie-success-add'),
                      renderer: 'svg',
                      loop: true,
                      autoplay: true,
                      path: '/assets/success.json'
                    })
                  }
                });

              }
            }
            return; // Handler selesai untuk event ini
          }


          // Filter event QR hanya untuk instance aktif di modal
          if (wsData.data?.instance_id !== this.currentInstanceId) {
            console.log('Event bukan untuk instance ini');
            return;
          }

          // Handler untuk QR code events
          if (wsData.event === 'QR_GENERATED') {
            console.log('QR_GENERATED event received');
            
            if (wsData.data?.instance_id === this.currentInstanceId) {
              const qrString = wsData.data?.qr_data; // Changed from qr to qr_data based on original code
              
              if (qrString) {
                this.qrImage = await this.qrStringToImage(qrString);
                this.qrStatus = 'ready';
                console.log('QR image set, status: ready');
              }
            }
          }

          if (wsData.event === 'QR_SUCCESS') {
            console.log('QR_SUCCESS event received');
            
            if (wsData.data?.instance_id === this.currentInstanceId) {
              this.qrStatus = 'qr_success';
              this.qrImage = null;
              console.log('QR scanned successfully, waiting for pairing...');
            }
          }

          if (wsData.event === 'QR_TIMEOUT') {
            console.log('QR_TIMEOUT event received');
            
            if (wsData.data?.instance_id === this.currentInstanceId) {
              this.qrStatus = 'timeout';
              this.qrImage = null;
              console.log('QR generation timeout');
            }
          }

          if (wsData.event === 'QR_ERROR') {
            console.log('QR_ERROR event received');
            
            if (wsData.data?.instance_id === this.currentInstanceId) {
              this.qrStatus = 'error';
              this.qrError = wsData.data?.error || 'QR generation failed'; // Changed from message to error based on original code
              this.qrImage = null;
              console.log('QR error:', this.qrError);
            }
          }

        } catch (error) {
          console.error('WebSocket parse error:', error);
        }
      },

      //convert qr ke image
      async qrStringToImage(qrString) {
        try {
          console.log('Generating QR image from string:', qrString);
          
          const qrDataUrl = await QRCode.toDataURL(qrString, {
            width: 300,
            margin: 2,
            color: {
              dark: '#000000',
              light: '#FFFFFF'
            }
          });
          
          console.log('QR image generated successfully');
          return qrDataUrl; // Returns data:image/png;base64,...
          
        } catch (error) {
          console.error('Failed to generate QR image:', error);
          this.qrError = 'Failed to generate QR image';
          return null;
        }
      },

      // View instance detail
      async viewInstanceDetail(item) {
        await this.$swal.fire({
          title: 'Instance Detail',
          html: `
            <div id="lottie-detail" style="width:180px; height:180px; margin:0 auto;"></div>
            <div class="text-start mt-3">
              <table class="table table-sm table-bordered">
                <tbody>
                  <tr>
                    <td class="fw-bold" style="width: 40%;">Instance ID</td>
                    <td>${item.instanceId}</td>
                  </tr>
                  <tr>
                    <td class="fw-bold">Phone Number</td>
                    <td>${item.phoneNumber || '-'}</td>
                  </tr>
                  <tr>
                    <td class="fw-bold">Status</td>
                    <td>
                      <span class="badge ${
                        item.status === 'online' ? 'bg-success' :
                        item.status === 'qr_required' ? 'bg-warning' :
                        item.status === 'logged_out' ? 'bg-secondary' : 'bg-danger'
                      }">
                        ${item.status}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="fw-bold">Connected</td>
                    <td>
                      <i class="bi ${item.isConnected ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'}"></i>
                      ${item.isConnected ? 'Yes' : 'No'}
                    </td>
                  </tr>
                  <tr>
                    <td class="fw-bold">Circle/Group</td>
                    <td>${item.circle || '-'}</td>
                  </tr>
                  <tr>
                    <td class="fw-bold">Used</td>
                    <td>
                      <i class="bi ${item.used ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-secondary'}"></i>
                      ${item.used ? 'Siap Digunakan' : 'Tidak Tersedia'}
                    </td>
                  </tr>
                  <tr>
                    <td class="fw-bold">Webhook URL</td>
                    <td style="word-break: break-all;">${item.webhookUrl || item.webhook_url || '-'}</td>
                  </tr>
                  <tr>
                    <td class="fw-bold">Webhook Secret</td>
                    <td style="word-break: break-all;">${item.secret || item.webhookSecret || item.webhook_secret || '-'}</td>
                  </tr>
                  <tr>
                    <td class="fw-bold">Keterangan</td>
                    <td style="white-space: pre-wrap;">${item.keterangan || '-'}</td>
                  </tr>
                  <tr>
                    <td class="fw-bold">Created At</td>
                    <td>${this.formatDate(item.createdAt)}</td>
                  </tr>
                  <tr>
                    <td class="fw-bold">Connected At</td>
                    <td>${item.connectedAt ? this.formatDate(item.connectedAt) : '-'}</td>
                  </tr>
                  <tr>
                    <td class="fw-bold">Last Seen</td>
                    <td>${item.lastSeen ? this.formatDate(item.lastSeen) : '-'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          `,
          confirmButtonText: 'Close',
          confirmButtonColor: '#6c757d',
          width: '600px',

          didOpen: () => {
            lottie.loadAnimation({
              container: document.getElementById('lottie-detail'),
              renderer: 'svg',
              loop: true,
              autoplay: true,
              path: '/assets/success.json'
            });
          }
        });
      },

      // Open edit instance modal with SweetAlert
      async openEditModal(item) {
        const result = await this.$swal.fire({
          title: 'Edit Instance',
          html: `
            <div id="lottie-edit" style="width:180px; height:180px; margin:0 auto;"></div>
            <div class="text-start mt-3">
              <div class="mb-3">
                <label class="form-label fw-bold">Instance ID</label>
                <input type="text" class="form-control" value="${item.instanceId}" disabled>
              </div>
              <div class="mb-3">
                <label class="form-label fw-bold">Phone Number</label>
                <input type="text" class="form-control" value="${item.phoneNumber || '-'}" disabled>
              </div>
              <div class="mb-3">
                <label class="form-label fw-bold">Status</label>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="swal-used-switch" ${item.used ? 'checked' : ''}>
                  <label class="form-check-label" for="swal-used-switch" id="swal-used-label">
                    ${item.used ? 'Siap Digunakan' : 'Tidak Tersedia'}
                  </label>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label fw-bold">Circle/Group</label>
                <select id="swal-circle" class="form-control">
                  <option value="">-- Pilih kelompok --</option>
                  <option value="one" ${item.circle === 'one' ? 'selected' : ''}>one</option>
                  <option value="two" ${item.circle === 'two' ? 'selected' : ''}>two</option>
                  <option value="three" ${item.circle === 'three' ? 'selected' : ''}>three</option>
                  <option value="four" ${item.circle === 'four' ? 'selected' : ''}>four</option>
                  <option value="five" ${item.circle === 'five' ? 'selected' : ''}>five</option>
                  <option value="six" ${item.circle === 'six' ? 'selected' : ''}>six</option>
                  <option value="seven" ${item.circle === 'seven' ? 'selected' : ''}>seven</option>
                  <option value="eight" ${item.circle === 'eight' ? 'selected' : ''}>eight</option>
                  <option value="nine" ${item.circle === 'nine' ? 'selected' : ''}>nine</option>
                  <option value="ten" ${item.circle === 'ten' ? 'selected' : ''}>ten</option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label fw-bold">Keterangan</label>
                <textarea id="swal-keterangan" class="form-control" rows="3" placeholder="Masukkan catatan untuk instance ini...">${item.keterangan || ''}</textarea>
              </div>
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: 'Simpan',
          cancelButtonText: 'Batal',
          confirmButtonColor: this.themeColor,
          cancelButtonColor: '#6c757d',
          width: '500px',

          didOpen: () => {
            lottie.loadAnimation({
              container: document.getElementById('lottie-edit'),
              renderer: 'svg',
              loop: true,
              autoplay: true,
              path: '/assets/input.json'
            });

            // Add event listener for switch toggle
            const switchEl = document.getElementById('swal-used-switch');
            const labelEl = document.getElementById('swal-used-label');
            switchEl.addEventListener('change', (e) => {
              labelEl.textContent = e.target.checked ? 'Siap Digunakan' : 'Tidak Tersedia';
            });
          },

          preConfirm: () => {
            const used = document.getElementById('swal-used-switch').checked;
            const circle = document.getElementById('swal-circle').value;
            const keterangan = document.getElementById('swal-keterangan').value;
            
            if (!circle) {
              this.$swal.showValidationMessage('Circle/Group wajib dipilih');
              return false;
            }
            
            return { used, circle, keterangan };
          }
        });

        if (!result.isConfirmed || !result.value) return;

        // Save changes
        try {
          this.loading = true;

          const response = await axios.patch(
            `${this.baseUrl}/api/instances/${item.instanceId}`,
            {
              used: result.value.used,
              circle: result.value.circle,
              keterangan: result.value.keterangan
            },
            { withCredentials: true }
          );

          if (response.data.success) {
            // Update item in list
            item.used = result.value.used;
            item.circle = result.value.circle;
            item.keterangan = result.value.keterangan;

            // Success alert
            await this.$swal.fire({
              title: 'Berhasil!',
              html: `
                <div id="lottie-success-edit" style="width:200px; height:200px; margin:0 auto;"></div>
                <p class="mt-2">Instance berhasil diupdate.</p>
              `,
              confirmButtonText: 'OK',
              confirmButtonColor: this.themeColor,

              didOpen: () => {
                lottie.loadAnimation({
                  container: document.getElementById('lottie-success-edit'),
                  renderer: 'svg',
                  loop: true,
                  autoplay: true,
                  path: '/assets/success.json'
                });
              }
            });
          } else {
            this.Toasttt(response.data?.message || 'Gagal update instance.', 'error');
          }

          await this.fetchData();
        } catch (error) {
          console.error('Failed to update instance:', error);
          this.Toasttt(
            'Gagal update instance',
            'error',
            error?.response?.data?.message || ''
          );
        } finally {
          this.loading = false;
        }
      },

      // Open Webhook Settings modal with SweetAlert
      async openWebhookModal(item) {
        const currentUrl = item.webhookUrl || item.webhook_url || '';
        const currentSecret = item.secret || item.webhookSecret || item.webhook_secret || '';

        const result = await this.$swal.fire({
          title: 'Webhook Settings',
          html: `
            <div id="lottie-webhook" style="width:130px; height:130px; margin:0 auto;"></div>
            <p class="text-muted small mb-2">Konfigurasi endpoint webhook untuk instance <b>${item.instanceId?.substring(0, 6)}</b></p>
            
            <!-- Panduan Info Webhook Instance -->
            <div class="alert alert-info border-0 rounded-3 text-start p-2 mb-3" style="background-color: #e8f4fd; font-size: 0.78rem; line-height: 1.4;">
              <div class="d-flex align-items-start">
                <i class="bi bi-info-circle-fill text-primary me-2 fs-6 mt-1"></i>
                <div>
                  <div class="fw-bold text-primary mb-1">📘 Webhook Menu "Instance" (Incoming Messages):</div>
                  <ul class="ps-3 mb-1">
                    <li><b>Fungsi:</b> Menerima Pesan Masuk (Incoming Messages).</li>
                    <li><b>Cara Kerja:</b> Setiap ada chat masuk dari customer/orang lain ke nomor WhatsApp Anda, server otomatis mem-forward data pesan ke URL ini secara real-time.</li>
                    <li><b>Cocok untuk:</b> Bot Auto-Reply, CRM/Helpdesk, atau riwayat chat masuk.</li>
                  </ul>
                  <div class="text-secondary" style="font-size: 0.73rem;">
                    💡 <i>Gunakan Webhook Worker jika ingin memantau laporan status pengiriman pesan keluar (Delivery Report).</i>
                  </div>
                </div>
              </div>
            </div>

            <div class="webhook-form-container text-start">
              <div class="mb-3">
                <label class="form-label text-secondary fw-semibold small mb-1">
                  <i class="bi bi-hdd-network me-1"></i> Instance ID
                </label>
                <div class="input-group">
                  <span class="input-group-text bg-light text-muted border-end-0"><i class="bi bi-qr-code"></i></span>
                  <input type="text" class="form-control bg-light border-start-0 text-muted" value="${item.instanceId}" readonly>
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label text-dark fw-semibold small mb-1">
                  <i class="bi bi-link-45deg me-1"></i> Webhook URL <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <span class="input-group-text bg-white"><i class="bi bi-globe2 text-primary"></i></span>
                  <input 
                    type="url" 
                    id="swal-webhook-url" 
                    class="form-control" 
                    placeholder="https://your-domain.com/webhook" 
                    value="${currentUrl}"
                    autocomplete="off"
                  >
                </div>
                <div class="text-muted mt-1" style="font-size: 0.78rem;">
                  <i class="bi bi-info-circle me-1"></i>URL endpoint untuk menerima kiriman payload event WhatsApp.
                </div>
              </div>

              <div class="mb-2">
                <label class="form-label text-dark fw-semibold small mb-1">
                  <i class="bi bi-shield-lock me-1"></i> Webhook Secret <span class="badge bg-light text-secondary border ms-1 fw-normal">Optional</span>
                </label>
                <div class="input-group">
                  <span class="input-group-text bg-white"><i class="bi bi-key text-primary"></i></span>
                  <input 
                    type="password" 
                    id="swal-webhook-secret" 
                    class="form-control border-end-0" 
                    placeholder="Masukkan secret token jika ada" 
                    value="${currentSecret}"
                    autocomplete="new-password"
                  >
                  <button class="btn btn-outline-secondary border-start-0 bg-white" type="button" id="btn-toggle-secret" title="Lihat/Sembunyikan Secret" style="border-color: #dee2e6;">
                    <i class="bi bi-eye text-muted" id="icon-toggle-secret"></i>
                  </button>
                </div>
                <div class="text-muted mt-1" style="font-size: 0.78rem;">
                  <i class="bi bi-info-circle me-1"></i>Token rahasia untuk validasi signature (HMAC payload).
                </div>
              </div>
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: '<i class="bi bi-check2-circle me-1"></i> Simpan Webhook',
          cancelButtonText: 'Batal',
          confirmButtonColor: this.themeColor,
          cancelButtonColor: '#6c757d',
          width: '540px',
          customClass: {
            popup: 'swal2-custom-rounded',
            confirmButton: 'px-4 py-2 shadow-sm',
            cancelButton: 'px-4 py-2'
          },

          didOpen: () => {
            lottie.loadAnimation({
              container: document.getElementById('lottie-webhook'),
              renderer: 'svg',
              loop: true,
              autoplay: true,
              path: '/assets/input.json'
            });

            // Toggle show/hide password
            const toggleBtn = document.getElementById('btn-toggle-secret');
            const secretInput = document.getElementById('swal-webhook-secret');
            const iconSecret = document.getElementById('icon-toggle-secret');
            if (toggleBtn && secretInput && iconSecret) {
              toggleBtn.addEventListener('click', () => {
                if (secretInput.type === 'password') {
                  secretInput.type = 'text';
                  iconSecret.className = 'bi bi-eye-slash';
                } else {
                  secretInput.type = 'password';
                  iconSecret.className = 'bi bi-eye';
                }
              });
            }
          },

          preConfirm: () => {
            const url = document.getElementById('swal-webhook-url').value?.trim();
            const secret = document.getElementById('swal-webhook-secret').value?.trim();

            if (!url) {
              this.$swal.showValidationMessage('Webhook URL wajib diisi');
              return false;
            }

            return { url, secret };
          }
        });

        if (!result.isConfirmed || !result.value) return;

        try {
          this.loading = true;

          const payload = {
            url: result.value.url
          };
          if (result.value.secret) {
            payload.secret = result.value.secret;
          }

          const response = await axios.post(
            `${this.baseUrl}/api/instances/${item.instanceId}/webhook-setconfig`,
            payload,
            { withCredentials: true }
          );

          if (response.data.success) {
            // Update item in local list jika ada data balik
            if (response.data.data) {
              item.webhookUrl = response.data.data.webhookUrl;
              item.secret = response.data.data.secret;
            }

            await this.$swal.fire({
              title: 'Berhasil!',
              html: `
                <div id="lottie-success-webhook" style="width:200px; height:200px; margin:0 auto;"></div>
                <p class="mt-2">${response.data.message || 'Webhook config berhasil disimpan.'}</p>
              `,
              confirmButtonText: 'OK',
              confirmButtonColor: this.themeColor,

              didOpen: () => {
                lottie.loadAnimation({
                  container: document.getElementById('lottie-success-webhook'),
                  renderer: 'svg',
                  loop: true,
                  autoplay: true,
                  path: '/assets/success.json'
                });
              }
            });
          } else {
            this.Toasttt(response.data?.message || 'Gagal update webhook config.', 'error');
          }

          await this.fetchData();
        } catch (error) {
          console.error('Failed to update webhook config:', error);
          this.Toasttt(
            'Gagal update webhook config',
            'error',
            error?.response?.data?.message || ''
          );
        } finally {
          this.loading = false;
        }
      },
    
      Toasttt(msg, type, detail){
        const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            background: "#F8F8F8",
            didOpen: (toast) => {
                toast.onmouseenter = this.$swal.stopTimer;
                toast.onmouseleave = this.$swal.resumeTimer;
            }
        });
            Toast.fire({
            icon: type,
            title: msg,
            text: detail,
        });
      },

      formatDate(value) {
        if (!value) return '-'
        const d = new Date(value)
        return d.toLocaleString('id-ID', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
      },

      formatStatusLabel(item) {

          if (!item || !item.status) return '-'

          switch (item.status) {
            case 'qr_required':
              return 'QR REQUIRED'
            case 'online':
              return 'ONLINE'
            case 'logged_out':
              return 'LOGOUT'
            case 'disconnected':
              return 'DISCONNECTED'
            default:
              return (item.status || '-').toUpperCase()
          }
        },


        cleanupModal() {
          // Bersihkan class dan style yang menempel di body/html akibat modal
          document.body.classList.remove('modal-open');
          document.body.style.removeProperty('padding-right');
          document.body.style.removeProperty('overflow');
          document.documentElement.style.removeProperty('overflow');

          // Hapus sisa-sisa backdrop jika masih ada
          const backdrops = document.querySelectorAll('.modal-backdrop');
          backdrops.forEach(el => el.remove());
        }

    },
  } 
  </script>

  
<style scope>
.swal2-custom-rounded {
  border-radius: 16px !important;
  padding: 1.5rem !important;
}

.webhook-form-container .input-group-text {
  border-color: #dee2e6;
  font-size: 0.95rem;
}

.webhook-form-container .form-control {
  border-color: #dee2e6;
  font-size: 0.9rem;
  padding: 0.55rem 0.75rem;
}

.webhook-form-container .form-control:focus {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
}

.webhook-form-container input[readonly] {
  background-color: #f8f9fa !important;
  color: #6c757d !important;
  font-family: monospace;
  font-size: 0.85rem;
}
</style>
